import axios from 'axios';
import { tokenManager } from './auth';

// API 기본 URL 설정
const protocol = window.location.protocol; // 'https:' 또는 'http:'
const hostname = window.location.hostname;
// 개발 환경에서는 직접 백엔드 포트로, 프로덕션에서는 아파치 프록시 사용
const API_BASE_URL = hostname === 'localhost'
  ? `${protocol}//${hostname}:22500/api`  // 로컬 개발
  : `${protocol}//${hostname}/persona-content-gen-api/api`;  // 프로덕션 (아파치)

// axios 인스턴스 생성
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 요청 인터셉터 - 모든 요청에 토큰 추가
axiosInstance.interceptors.request.use(
  (config) => {
    const token = tokenManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 401 에러 처리
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 401 에러이고 재시도하지 않은 경우
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // 토큰이 만료된 경우 로그인 페이지로 리다이렉트
      tokenManager.removeToken();
      window.location.href = '/login';
    }

    // 403 에러 - 권한 없음
    if (error.response?.status === 403) {
      console.error('접근 권한이 없습니다.');
    }

    // 500 에러 - 서버 에러
    if (error.response?.status >= 500) {
      console.error('서버 오류가 발생했습니다.');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

// 기본 axios 설정도 업데이트
export const setupAxiosDefaults = () => {
  const token = tokenManager.getToken();
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  axios.defaults.baseURL = API_BASE_URL;
};

// App.js에서 사용하는 함수명으로 export
const setupAxiosInterceptors = () => {
  setupAxiosDefaults();
};

export { setupAxiosInterceptors };